<template>
  <header class="ds-card-title">
    <div
      v-if="icon"
      class="ds-card-title-icon"
    >
      <v-icon
        size="24"
        color="black"
      >
        {{ icon }}
      </v-icon>
    </div>

    <div class="ds-card-title-title">
      <slot />
    </div>

    <div class="ds-card-title-actions">
      <slot name="actions" />
    </div>
  </header>
</template>

<script>
export default {
  name: 'DsCardTitle',
  props: {
    icon: {
      type: String,
      default: undefined,
    },
  },
};
</script>
<style lang="stylus" scoped>
@import "../../assets/stylus/variables.styl"

.ds-card-title {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;

  &-title {
    color: $nx-neutral-900;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
    flex-grow 1
  }
}
</style>
